// When the page is restored from the back/forward cache, the CTA can come
// back painted in its hover/focus colour (stuck :hover snapshot or restored
// focus). Reset it to the default state until the user actually interacts.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  const buttons = document.querySelectorAll('.section-athraah-journey__button');
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button === document.activeElement) button.blur();
    button.classList.add('section-athraah-journey__button--state-reset');
  });

  const clearReset = () => {
    buttons.forEach((button) => {
      button.classList.remove('section-athraah-journey__button--state-reset');
    });
  };
  document.addEventListener('pointermove', clearReset, { once: true });
  document.addEventListener('pointerdown', clearReset, { once: true });
  document.addEventListener('keydown', clearReset, { once: true });
});
